import React, {Component} from 'react';
import classNames from 'classnames';
import AppTopbar from './AppTopbar';
import {AppFooter} from './AppFooter';
import {AppMenu} from './AppMenu';
import AppProfile from './AppProfile';
import Session from '../auth/Session';
import VideoCallApp from '../videocall/App';
import { withRouter } from "react-router-dom";

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '../layout/layout.scss';
import './layout.css';
import '../backoffice/theme_light.css';

class Layout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            layoutMode: 'static',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false
        };

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
    
        this.user = Session.getCookie();
        const technicalRoles = ['SECURITY', 'ASSISTENT'];
        if (technicalRoles.includes(this.user.role1)) {
            this.props.history.replace({ pathname: '/technical' });
        }
        if (!this.user.client_id) {
            this.props.history.replace({ pathname: '/' });
        }
        
        this.createMenu();
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            }
            else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        }
        else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }
       
        event.preventDefault();
    }

    onSidebarClick(event) {
        this.menuClick = true;
    }

    onMenuItemClick(event) {
        if(!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    createMenu() {
        this.menu = [
            {
               label:'Inicio',
               icon:'pi pi-fw pi-home',
               url: '#/client'
            },
            {
                label: 'As Minhas Tarefas',
                icon:'pi pi-fw pi-calendar',
                url: '#/client/diary'
            },
            {
                label:'A Minha Informação',
                icon:'pi pi-fw pi-heart',
                url: '#/client/info/view'
            },
            {
                label: 'Conteúdos',
                icon:'pi pi-fw pi-info',
                url: '#/client/topics/list'
            },
            {
                label: 'As Minhas Ausências',
                icon:'pi pi-fw pi-clock',
                url: '#/client/out/list'
            },
            {
                label: 'Atividades Inscritas',
                icon:'pi pi-fw pi-briefcase',
                url: '#/client/activities/list'
            }
        ];
    }

    addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate() {
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }

    render() {
        
        const wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });

        const sidebarClassName = classNames("layout-sidebar", {
            'layout-sidebar-dark': this.state.layoutColorMode === 'dark',
            'layout-sidebar-light': this.state.layoutColorMode === 'light'
        });

        return (
            <div className={wrapperClass} onClick={this.onWrapperClick}>

                <AppTopbar onToggleMenu={this.onToggleMenu}/>

                <div ref={(el) => this.sidebar = el} 
                    className={sidebarClassName} 
                    onClick={this.onSidebarClick}>
                    <AppProfile onMenuItemClick={this.onMenuItemClick} />
                    <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                </div>

                <div className="layout-main">
                    { this.props.children }
                </div>

                <AppFooter />

                <div className="layout-mask"></div>

                <VideoCallApp username={this.user.username} />

            </div>
        );
    }
}

export default withRouter(Layout);